import React, { useContext } from "react";
import { Grid, TextField } from "@material-ui/core";

// Contexts
import CampaignContext from "../../../../context/campaign/CampaignContext";
import ParameterContext from "../../../../context/parameters/ParameterContext";

const CheckoutDetails = () => {
  const { form_data, setFormData } = useContext(CampaignContext);
  const { checkout_languages } = useContext(ParameterContext);

  const handleChange = (e) => {
    const id = e.target.id;
    const value = e.target.value;

    if (id === "language") {
      form_data[id] = value;
      setFormData(form_data);
    }
  };

  return (
    <Grid item xs={12} spacing={2} container alignItems="flex-start">
      {/* Language */}
      <Grid item xs={2}>
        <TextField
          required
          fullWidth
          size="small"
          margin="dense"
          variant="outlined"
          select
          SelectProps={{
            native: true,
          }}
          label="Language"
          id="language"
          name="language"
          onChange={handleChange}
          value={form_data.language}
        >
          {checkout_languages ? (
            checkout_languages.map((each) => {
              return (
                <option key={each.code} value={each.code}>                 
                  {each.name}
                </option>
              );
            })
          ) : (
            <option value="" disabled />
          )}
        </TextField>
      </Grid>
    </Grid>
  );
};

export default CheckoutDetails;
